import React, { useEffect, useRef } from "react";
import setInnerHTML from "../../../lib/setInnerHTML";
import { ComponentProps, ComponentWidth } from "../../../types";
import { SectionWrapper } from "../../containers/SectionWrapper";
import * as styles from "./Embed.module.css";
import IframeResizer from "iframe-resizer-react";
import parse from "html-react-parser";

interface Props extends ComponentWidth, ComponentProps {
  code: string;
}

export const Embed: React.FC<Props> = ({ code, width, ...props }) => {
  const containerEl = useRef<HTMLDivElement>(null);
  const contentClasses = [styles.content];

  if (width === "contained") {
    contentClasses.push(styles.contained);
  }

  let parsedCode = parse(code);

  if (parsedCode.type === "iframe") {
    const src = parsedCode.props.src;

    return (
      <SectionWrapper {...props}>
        <div className={styles.embed}>
          <div
            className={contentClasses.join(" ")}
            data-kontent-element-codename="embed_code"
          >
            <IframeResizer
              src={src}
              minHeight={parsedCode.props.height}
              style={{ width: "1px", minWidth: "100%" }}
            />
          </div>
        </div>
      </SectionWrapper>
    );
  }

  useEffect(() => {
    if (containerEl?.current) {
      setInnerHTML(containerEl.current, code);
    }
  }, []);

  return (
    <SectionWrapper {...props}>
      <div className={styles.embed}>
        <div
          className={contentClasses.join(" ")}
          data-kontent-element-codename="embed_code"
          ref={containerEl}
        />
      </div>
    </SectionWrapper>
  );
};
